import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-system-log-type-data-ssystem-log-type-data-sector-condition',
  templateUrl: './system-log-type-data-ssystem-log-type-data-sector-condition.component.html',
  styleUrls: ['./system-log-type-data-ssystem-log-type-data-sector-condition.component.scss']
})
export class SystemLogTypeDataSSystemLogTypeDataSectorConditionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
